import React from 'react';
import DropdownWrapper from './dropdown-wrapper';

const ActivityDropdown = ({items, selectItem, dropdownLabel}) => {
	return (
		<DropdownWrapper label={dropdownLabel}>
			<div className="activity-dropdown">
				{items.map((item, idx) => {
					const itemLabel = item.label.split(' ')[0].toLowerCase();

					return (
						<li key={idx}
							className={`dropdown-item has-dot ${itemLabel}`}
							onClick={() => selectItem(idx)}>
							<span>{item.label}</span>
							<span className={`dot ${itemLabel}`}></span>
						</li>
					);
				})}
			</div>
		</DropdownWrapper>
	);
};

export default ActivityDropdown;
